import { render, staticRenderFns } from "./aiMessage.vue?vue&type=template&id=020ee9cc&scoped=true&"
import script from "./aiMessage.vue?vue&type=script&lang=js&"
export * from "./aiMessage.vue?vue&type=script&lang=js&"
import style0 from "./aiMessage.vue?vue&type=style&index=0&id=020ee9cc&lang=less&scoped=true&"
import style1 from "./aiMessage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020ee9cc",
  null
  
)

component.options.__file = "aiMessage.vue"
export default component.exports